import { createApp, h } from "vue";

import { IStudent, IAnonymousStudent, TSnowplow } from "@/interfaces/external-services.interface";
import { IEventAggregationService, ISessionService } from '@studyportals/student-interfaces';

import { LoginStatusCheckerPlugin } from "@/domain/login-status-checker-plugin";
import store from '@/store';
import App from '@/presentation/app.vue';

declare global {
	interface Window {
		snowplow?: TSnowplow;
		SessionService?: ISessionService,
		AnonymousStudent?: IAnonymousStudent,
		EventAggregationService?: IEventAggregationService,
		Student?: IStudent
	}
}

void (new LoginStatusCheckerPlugin()).getHandler();

store.actions.retrieveStoredAnswers();
store.actions.setOriginPortal();

const app = createApp({
	render: () => {
		return h(App);
	}
})

app.provide('store', store);
app.mount('#PersonalityTestPlaceholder');
